const state = {
  sideBar: true,
  configType: '',
  configTypes: ['config', 'theme', 'css'],
  usagePage: '',
  showCasePage: '',
  reloadCashier: 0,
  allPresets: [],
  preset: 'Default',
  presetsToShowCase: [],
  reloadCashierCarousel: 0
}

const mutations = {
  updateReloadCashierCarousel (state) {
    state.reloadCashierCarousel++
  },
  setPresets (state, presets) {
    state.allPresets = presets
  },
  setPresetsToShowCase: (state, presets) => {
    state.presetsToShowCase = presets
  },
  sideBarMutation: (state, payload) => {
    state.sideBar = payload
  },
  configTypeMutation: (state, payload) => {
    state.configType = payload
  },
  reloadCashierMutation: (state) => {
    try {
      window._PaymentIQCashierReset()
      // const cashierPreview = document.querySelector('#cashier-preview')
      // if (cashierPreview) cashierPreview.innerHTML = ''
    } catch (err) { console.log(err) }
    state.reloadCashier++
  },
  setPresetName (state, preset) {
    state.preset = preset
  },
  setUsagePage (state, page) {
    state.usagePage = page
  },
  setShowCasePage (state, page) {
    state.showCasePage = page
  }
}

const actions = {
}

export default {
  state,
  mutations,
  actions
}
